import { Form, formsApiResponseSchema, formSchema, FormsApiResponse } from '@repo/shared/domain';
import { constructQuery } from '@repo/shared/helpers';
import { guardedClient as clientRequest } from '@repo/shared/helpers';

export const getForm = async (formId: string, language?: string): Promise<Form | undefined> => {
	const query = constructQuery({ language });
	try {
		const { body } = await clientRequest.get(`/api/forms/${formId}?${query}`, {
			schema: formSchema,
		});
		return body;
	} catch (error) {
		console.error('Failed to get form:', error);
		return undefined;
	}
};

// Forms
export const getForms = async (query?: string): Promise<FormsApiResponse> => {
	const { body } = await clientRequest.get(`/api/forms${query ? `?${query}` : ''}`, {
		schema: formsApiResponseSchema,
	});
	return body;
};

export const getFormBySlug = async (slug: string, language?: string): Promise<Form | undefined> => {
	const query = constructQuery({ language });
	try {
		const { body } = await clientRequest.get(`/api/forms/${slug}?${query}`, {
			schema: formSchema,
		});
		return body;
	} catch (error) {
		console.error('Failed to get form:', error);
		return undefined;
	}
};

export const createForm = async (data: Partial<Form>) => {
	return clientRequest.post('/api/forms/', data);
};

export const updateForm = async (id: string, data: Partial<Form>) => {
	return clientRequest.put(`/api/forms/${id}`, data);
};
